import { getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Gets the buyer data.
 */
export const getBuyer = factoryAuthService(({ id }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/kpi/organismo/${id}`)
)

/**
 * Gets the KPIs of the given buyer of the given year.
 */
export const getBuyerKPIs = factoryAuthService(({ id, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/calculo/montokpi/${id}/${year}/9`)
)

/**
 * To get the indicators details.
 */
export const getBuyerIndicators = factoryAuthService(({ id, type, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankey/getIndicatorDetalle/${year}/${id}/${type}`)
)

/**
 * Gets the buyers size by the given year and sector.
 */
export const getBuyersSize = factoryAuthService(({ sectorId, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismBuyer/sizeSupplier/${year}/${sectorId}`)
)

/**
 * Gets the traded amounts of the year by a monthly distribution.
 */
export const getBuyersTradedAmountsMonthly = factoryAuthService(({ mechanismId, sectorsIds, year }) => {
  const body = {
    year,
    idModalidad: mechanismId,
    idSector: sectorsIds
  }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismBuyer/monthlyDistribution`, { body })
})

/**
 * Gets the traded amounts of the year by a yearly distribution.
 */
export const getBuyersTradedAmountsYearly = factoryAuthService(({ mechanismId, sectorsIds, year }) => {
  const body = {
    year,
    idModalidad: mechanismId,
    idSector: sectorsIds
  }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/organismBuyer/yearlyDistribution`, { body })
})
